import React from 'react';
import styled, { css } from 'styled-components';
import { MAX_CONTENT_SCREEN_WIDTH, MD_GRID_MAX_WIDTH, ONE_COLUMN_MAX_WIDTH, TWO_COLUMN_MAX_WIDTH, } from '../../Grid';
import { cssSpacing } from '@spotify-internal/encore-web';
const hideScrollbar = css `
  ::-webkit-scrollbar {
    display: none;
  }
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
`;
const Container = styled.div `
  overflow: hidden; /* Hide the scrollbar from the inner div */
  position: relative;

  // allow full bleed
  @media (max-width: ${MAX_CONTENT_SCREEN_WIDTH}) {
    width: unset;
    margin-inline: -${cssSpacing('looser-3')};
    button:last-child {
      padding-inline-end: ${cssSpacing('looser-3')};
    }
  }
  @media (max-width: ${MD_GRID_MAX_WIDTH}) {
    margin-inline: -${cssSpacing('looser-3')};
    button:last-child {
      padding-inline-end: ${cssSpacing('looser-3')};
    }
  }
  @media (max-width: ${TWO_COLUMN_MAX_WIDTH}) {
    margin-inline: -${cssSpacing('looser-3')};
    button:last-child {
      padding-inline-end: ${cssSpacing('looser-3')};
    }
  }
  @media (max-width: ${ONE_COLUMN_MAX_WIDTH}) {
    margin-inline: -${cssSpacing('base')};
    button:last-child {
      padding-inline-end: ${cssSpacing('base')};
    }
  }
`;
const ScrollableDivs = styled.div `
  display: flex; /* Make the list horizontal */
  overflow-y: hidden;
  overflow-x: auto; /* Enable horizontal scrolling */
  ${hideScrollbar}
  // allow full bleed
  @media (max-width: ${MAX_CONTENT_SCREEN_WIDTH}) {
    padding-inline: ${cssSpacing('looser-3')};
  }
  @media (max-width: ${MD_GRID_MAX_WIDTH}) {
    padding-inline: ${cssSpacing('looser-3')};
  }
  @media (max-width: ${TWO_COLUMN_MAX_WIDTH}) {
    padding-inline: ${cssSpacing('looser-3')};
  }
  @media (max-width: ${ONE_COLUMN_MAX_WIDTH}) {
    padding-inline: ${cssSpacing('base')};
  }
`;
const FullBleedHorizontalScroll = ({ children }) => (React.createElement(Container, null,
    React.createElement(ScrollableDivs, null, children)));
export default FullBleedHorizontalScroll;
